import { render, staticRenderFns } from "./DashboardFeedbacks.vue?vue&type=template&id=bb69a35a&scoped=true&"
import script from "./DashboardFeedbacks.vue?vue&type=script&lang=js&"
export * from "./DashboardFeedbacks.vue?vue&type=script&lang=js&"
import style0 from "./DashboardFeedbacks.vue?vue&type=style&index=0&id=bb69a35a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb69a35a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VCardText,VCardTitle,VChip,VContainer,VIcon,VSkeletonLoader})
